<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">현금영수증</span>
      <button class="btn-pop-close" @click="nonReceipt">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset">
        <span class="h2">현금영수증</span>
        <div class="ip-row flex">
          <!-- 라디오 -->
          <div class="custom-radio">
            <input
              type="radio"
              name="crType"
              value="2"
              id="indi"
              label="개인"
              checked
            />
            <label for="indi">개인</label>
          </div>
          <div class="custom-radio">
            <input
              type="radio"
              name="crType"
              value="1"
              id="busi"
              label="사업자"
            />
            <label for="busi">사업자</label>
          </div>
          <!-- //라디오 -->
          <input
            type="text"
            class="ip-comm ip-lg center"
            id="payCardNum"
            :value="cashReceiveNum"
          />
        </div>
      </div>
    </div>
    <div class="pop-btn-area">
      <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
      <button type="button" class="btn-pop btn-half btn-main" @click="receiptProcess('F')">
        자진발급<span class="overlay"></span>
      </button>
      <button type="button" class="btn-pop btn-half btn-main" @click="receiptProcess('Y')">
        핀패드<span class="overlay"></span>
      </button>
      <button type="button" class="btn-pop btn-half btn-main" @click="nonReceipt">
        미발급<span class="overlay"></span>
      </button>
      <button type="submit" class="btn-pop btn-half btn-submit" @click="receiptProcess('Y')">
        승인요청<span class="overlay"></span>
      </button>
    </div>
  </div>
  <PopupBtn2
      v-if="isPopupBtn2"
      :popupText="popupText"
      :popupTitle="popupTitle"
      @close="isPopupBtn2 = false"
      @setYes="setYes"
    />
</template>
<script>
import popupBtn2 from "@/components/popup/PopupBtn2.vue";

export default {
  name: "cashReceipt",
  props: {
    cashReceiveNum : String,
    payType: String,
  },
  data() {
    return {
      popupText : "",
      popupTitle : "",
      isPopupBtn2 : false,
    };
  },
  methods: {
    nonReceipt(){
      this.popupTitle ="현금영수증";
      this.popupText ="현금영수증을 미발행 하시겠습니까?";
      this.isPopupBtn2 = true;
    },
    setYes(){
      this.isPopupBtn2 = false;
      this.receiptProcess("N");
    },
    loadingPromise(text){
      this.$.emit('openLoading', text);
      return new Promise((resolve) => {
        setTimeout(()=>{
          this.$.emit('closeLoading');
          resolve(1);
        },1000)
      })
    },
    async receiptProcess(issuedYn){
      if(issuedYn=="Y"){
        await this.loadingPromise("현금영수증 발급 중입니다.");  
      }else if(issuedYn=="F"){
        await this.loadingPromise("자진발급 중입니다.");  
      }

      await this.loadingPromise("결제완료 처리 중입니다.");
      await this.loadingPromise("영수증 출력 중입니다.");
      this.$.emit('resetBasket',this.payType);
      this.$.emit('close');
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {
    PopupBtn2 : popupBtn2,
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


